import React from 'react';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import textSVG from '@plone/volto/icons/text.svg';

export default function addStyleMenuFontSize(config) {
  const { slate } = config.settings;

  slate.styleMenu = slate.styleMenu || {};
  slate.styleMenu.inlineStyles =
    slate.styleMenu.inlineStyles || [];

  slate.styleMenu.inlineStyles.push(
    {
      cssClass: 'font-size-small',
      label: 'Small',
      icon: () => (
        <Icon name={textSVG} size="24px" />
      ),
    },
    {
      cssClass: 'font-size-normal',
      label: 'Normal',
      icon: () => (
        <Icon name={textSVG} size="24px" />
      ),
    },
    {
      cssClass: 'font-size-large',
      label: 'Large',
      icon: () => (
        <Icon name={textSVG} size="24px" />
      ),
    },
    {
      cssClass: 'font-size-xlarge',
      label: 'Extra Large',
      icon: () => (
        <Icon name={textSVG} size="24px" />
      ),
    },
  );

  return config;
}